module.exports = __webpack_public_path__ + "static/media/square2.12ebe34e.svg";